import { Link, LinkProps } from "@chakra-ui/react";
import { Link as RouterLink, LinkProps as RouterLinkProps } from "react-router";

export function InterLink(props: Omit<LinkProps, "as"> & RouterLinkProps) {
    return <Link as={RouterLink} {...props} />;
}
